"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosGoogleBusinessConfigCreateInputSchema = exports.APosGoogleBusinessConfigSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosGoogleBusinessConfigSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    configId: id_schema_1.EntityIdSchema,
    locationId: id_schema_1.EntityIdSchema,
    googleAccountId: zod_1.z.string().optional(),
    googleLocationId: zod_1.z.string().optional(),
    businessName: zod_1.z.string().optional(),
    isConnected: zod_1.z.boolean().default(false),
    accessTokenEncrypted: zod_1.z.string().optional(),
    refreshTokenEncrypted: zod_1.z.string().optional(),
    tokenExpiresAt: zod_1.z.number().optional(),
    autoPostReviews: zod_1.z.boolean().default(false),
    autoUpdateHours: zod_1.z.boolean().default(false),
    autoUpdateMenu: zod_1.z.boolean().default(false),
    lastSyncAt: zod_1.z.number().optional(),
    syncErrors: zod_1.z.array(zod_1.z.string()).default([]),
}).merge(timestamps_schema_1.TimestampsSchema);
exports.APosGoogleBusinessConfigCreateInputSchema = zod_1.z.object({
    locationId: id_schema_1.EntityIdSchema,
    googleAccountId: zod_1.z.string().optional(),
    googleLocationId: zod_1.z.string().optional(),
    businessName: zod_1.z.string().optional(),
    autoPostReviews: zod_1.z.boolean().optional(),
    autoUpdateHours: zod_1.z.boolean().optional(),
    autoUpdateMenu: zod_1.z.boolean().optional(),
});
//# sourceMappingURL=google-business-config.schema.js.map